import React, { useEffect } from 'react';
import { Grid, Backdrop, CircularProgress, ThemeProvider, IconButton, Snackbar, Popover } from '@material-ui/core';
import { objAtrib, objText, properties, keysTablaGenericaPCT2, keysTablaGenericaPCT3, placeholderBuscador, constantesEstadosFase } from './BandejaSolicitudesData';
import customizate, { style, objStyle } from './BandejaSolicitudesStyle';
import { Alert } from '@material-ui/lab';
import { properties as AppData } from 'AppData';
import { useDispatch, useSelector } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';

//Importacion de componentes horizontales
import SelectSimple from '../../commons/SelectSimple/Select';
import Select from '../../commons/selectAutocomplete/SelectAutocomplete';
import Input from '../../commons/input/Input';
import Pager from '../../commons/pager/Pager';
import useOperations from './BandejaSolicitudesFunction';
import TablaGenerica from '../../commons/tablaGenerica/tablaGenerica';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { compProperties, properties as appProperties  } from './../../../AppData';
import { DialogMostrarCredito } from '../mostrarCreditos/DialogMostrarCredito';

import { useHistory } from "react-router-dom";
import { deleteState } from 'redux/slicers/kingdomOV3Slice';

//Contenedor de la pagina
export default function BandejaSolicitudes() {

  const history = useHistory();

  const { tituloPagina, situacionExp, estadoExp, selectSituacion, menuItem, selectEstado, buscador, isDisabled,
    handleChangeSituacion, handleChangeEstado, handleChangeBuscador, handleClickAcciones,
    headerTableObject, dataTableObject,
    getSituacion, getEstados, getValoresTabla, crearNuevaSolicitud, seleccionarFormulario,
    totalRecords, currentPage, paginate,
    isLoading, isPhoneVersion, updateFormat, funcionOrdena,
    ordenacionTipo, campoOrdenado, alerts, message, setMessage, refEstado, formatearTexto, mostrarFiltros, mostrarOcultarFiltros,
    setIsLoading, cerrarErrorDropRejected, errorDropRejected, mensajePopUp, busquedaPorBuscador, mensajeError, mostrarPopUpAviso,
    accionBorrar, cerrarPopUpAvisoAccion, mensajeTitulo, mostrarBotonNuevaSolicitudFunction, mostrarBotonNuevaSolicitud,
    obtenerProcedenciaConvocatoria, anchorEl, numMostrar, handleChangePager, refBuscador, pressBuscador, obtenerFasesEstados,
    showOrgSelector, listadoOrganismos, handleChangeOrganismo, handleIniciarSolicitud, handleCancelarSolicitud, mostrarPopUpCredito, setMostrarPopUpCredito
    , datosCredito } = useOperations();

  const accesoBandejaSol = useSelector((state) => state.kingdomOV3.accesoBandejaSol);
  const situacionCambiada = useSelector(state => state.kingdomOV3.situacionCambiada);
  const estadoCambiado = useSelector(state => state.kingdomOV3.estadoCambiado);
  const valorBuscado = useSelector(state => state.kingdomOV3.valorBuscado);

  const dispatch = useDispatch();

  //Almacenamiento de Hooks
  const customStyle = style();
  const objetoDatos = dataTableObject();
  const objetoCabecera = headerTableObject(funcionOrdena);

  //Variables de acceso rápido
  let situacion = properties.situacion;
  let estado = properties.estado;
  let pagina = properties.INIT_PAGE;

  /**Método que renderiza el paginador solo en versión ordenador */
  const renderPager = () => {
    if (!isPhoneVersion) {
      return <Grid item>
        <Pager recordsPerPage={numMostrar} totalRecords={totalRecords} currentPage={currentPage}
          paginate={paginate} numFilasMostrar={numMostrar} registrosTotales={totalRecords} handleChange={handleChangePager}
          numFilasPersonalizado={true} disabledRegistros={totalRecords < 5} anchorEl={anchorEl}
        />
      </Grid>
    }
  }

  // Se inserta el nombre del título de la página
  document.title = AppData.TITULO_PAGINA + tituloPagina;

  /////////////////////////////////////////////////////Llamadas a endPoints
  useEffect(() => {
    mostrarBotonNuevaSolicitudFunction();
    borrarValoresLocalStorage();
    getSituacion();
    getEstados(situacion);
    updateFormat();
    obtenerFasesEstados();
    return () => window.removeEventListener('resize', updateFormat);
  }, []);

  useEffect(() => {
    if (accesoBandejaSol !== undefined && accesoBandejaSol !== '') {
      dispatch(deleteState({ filnedName: 'accesoBandejaSol' }));
    }
    getValoresTabla(situacionCambiada || situacion, estadoCambiado || estado, pagina, campoOrdenado, ordenacionTipo, valorBuscado);
  }, [numMostrar]);

  /* Elimina los valores del estado global cuando se renderiza la página */
  const borrarValoresLocalStorage = () => {
    dispatch(insertNewState({ filnedName: 'modBajaRADA', value: true }));
    // Estados que contienen los estados a eliminar
    const stateToDelete = ['solicitudActual', 'fase', 'pdfSolicitud', 'idExpTrewa', 'accionModificar',
      'entidadSeleccionada', 'entidadesDeAlta'];

    // Se recorre el array que contiene los estados a eliminar y se procede a su eliminación
    for (let i = 0; i < stateToDelete.length; i++) {
      dispatch(deleteState({ filnedName: stateToDelete[i] }));
    }
  }

  /*Navegar a la pantalla Nueva Solicitud*/
  const onClickNuevaSolicitud = async (e) => {
    setIsLoading(true);
    await crearNuevaSolicitud();
  }

  window.addEventListener('resize', updateFormat);

  let keysTablaGenerica = obtenerProcedenciaConvocatoria() === 'PCT2' ? keysTablaGenericaPCT2 : keysTablaGenericaPCT3;

  return (
    <ThemeProvider theme={customizate(isPhoneVersion)}>
      {/*Grid principal*/}
      <Grid container spacing={12} {...objAtrib.gridPrincipal}>
        {isPhoneVersion &&
          <Grid {...objAtrib.gridBuscador} className={customStyle.classGridBuscadorResponsive}>
            <Grid container>
              <Input
                {...objAtrib.inputBuscador}
                classes={customStyle.classGrid}
                classInput={customStyle.classInput}
                value={buscador}
                onChange={handleChangeBuscador}
                inputRef={null}
                placeholder={obtenerProcedenciaConvocatoria() === 'PCT2' ? placeholderBuscador.pct2 : placeholderBuscador.pct3}
              />
              <IconButton
                disableRipple
                className={isPhoneVersion ? (customStyle.searchButtonPhone) : (customStyle.searchButton)}
                onClick={() => busquedaPorBuscador(situacion, estado, pagina, campoOrdenado, ordenacionTipo, valorBuscado)}>
                <img className={isPhoneVersion ? (customStyle.searchImgPhone) : (customStyle.searchImg)}
                  src={objAtrib.buscador.searchIconPath}
                  alt={objText.searchIconText}
                />
              </IconButton>
            </Grid>
          </Grid>
        }
        {/*Grid cabecera*/}
        <Grid {...objAtrib.gridCabecera} className={customStyle.classGridCabecera} container>
          {/*Titulo*/}
          <Grid {...objAtrib.gridTitulo}>
            <h2 {...objAtrib.tituloEncabezado} className={customStyle.classH2}>{tituloPagina}</h2>
          </Grid>
          {!isPhoneVersion &&
            <Grid {...objAtrib.gridBuscador} className={customStyle.classGridBuscador}>
              <Grid container>
                <Input
                  {...objAtrib.inputBuscador}
                  classes={customStyle.classGrid}
                  classInput={customStyle.classInput}
                  value={buscador}
                  onChange={handleChangeBuscador}
                  inputRef={null}
                  onKeyPress={pressBuscador}
                  placeholder={obtenerProcedenciaConvocatoria() === 'PCT2' ? placeholderBuscador.pct2 : placeholderBuscador.pct3}
                />
                <IconButton
                  ref={refBuscador}
                  disableRipple
                  className={isPhoneVersion ? (customStyle.searchButtonPhone) : (customStyle.searchButton)}
                  onClick={() => busquedaPorBuscador(situacion, estado, pagina, campoOrdenado, ordenacionTipo, valorBuscado)}>
                  <img className={isPhoneVersion ? (customStyle.searchImgPhone) : (customStyle.searchImg)}
                    src={objAtrib.buscador.searchIconPath}
                    alt={objText.searchIconText}
                  />
                </IconButton>
              </Grid>
            </Grid>
          }
          {/*Buscador Buscador*/}

        </Grid>
        {/*Grid contenedor*/}
        <Grid container spacing={3} {...objAtrib.gridContenedor} className={customStyle.classGridContenedor}>
          {isPhoneVersion ? <button {...objAtrib.button} className={customStyle.classButtonResponsive}>{objText.nombreButton}</button>
            : <Grid container xs={9} className={customStyle.classGridSelect}>
              {/*Selector Situacion*/}
              <SelectSimple
                {...objAtrib.selectSituacion}
                value={selectSituacion}
                onChange={handleChangeSituacion}
                map={menuItem(situacionExp)}
                disabled={isDisabled}
              />
              {/*Selector Estado*/}
              <Select
                {...objAtrib.selectEstado}
                classes={customStyle}
                options={estadoExp}
                getOptionLabel={(option) => option.nombre}
                onChange={handleChangeEstado}
                values={selectEstado}
                refSelect={refEstado}
                disabled={isDisabled}
              />
            </Grid>
          }
          {(() => {
            if (isPhoneVersion && mostrarFiltros) {
              return (
                <Grid className={customStyle.classSelectResponsive}>
                  {/*Selector Situacion*/}
                  <SelectSimple
                    {...objAtrib.selectSituacion}
                    value={selectSituacion}
                    onChange={handleChangeSituacion}
                    map={menuItem(situacionExp)}
                    disabled={isDisabled}
                  />
                  {/*Selector Estado*/}
                  <Select
                    {...objAtrib.selectEstado}
                    classes={customStyle}
                    options={estadoExp}
                    getOptionLabel={(option) => option.nombre}
                    onChange={handleChangeEstado}
                    values={selectEstado}
                    refSelect={refEstado}
                    disabled={isDisabled}
                  />
                </Grid>
              )
            }
          })()}

          {!isPhoneVersion ?
            <Grid item xs={2}>
              {mostrarBotonNuevaSolicitud &&
                <button {...objAtrib.button} onClick={onClickNuevaSolicitud} className={customStyle.classButton}>{objText.nombreButton}</button>
              }
            </Grid>
            : <Grid className={customStyle.classGridContenedor} >
              <button onClick={mostrarOcultarFiltros} {...objAtrib.button} className={customStyle.classButtonFilterResponsive}>{mostrarFiltros ? objText.buttonOcultarResponsiveSelects : objText.buttonResponsiveSelects}</button>
            </Grid>
          }



          {/*Grid contenedor tabla*/}
          <Grid container spacing={12} >
            <TablaGenerica
              tableData={objetoDatos}
              headingColumns={objetoCabecera}
              isPhoneVersion={isPhoneVersion}
              messageNoData={objText.TEXT_NO_DATOS}
              {...keysTablaGenerica}
            />
          </Grid>
          {/*Grid contendor Paginador*/}
          <Grid container {...objStyle.classGridPager} className={customStyle.classPager}>
            {renderPager()}
          </Grid>
        </Grid>
        <Backdrop className={customStyle.classBackdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Confirmacion
          accionConfirmacion={cerrarErrorDropRejected}
          titulo={mensajeTitulo}
          mostrar={errorDropRejected}
          isPhoneVersion={isPhoneVersion}
          mensaje={mensajeError}
          botonera={compProperties.CONFIR_SOLO_ACEPTAR}
          quitarImg={false}
          tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
          isPopUpPdf={false}
          textBotonConfirmarPersonalizado={false}
          isImagenPersonalizada={true}
          centrarContenido={true}
          imagen={properties.IMAGEN_ERROR}
          isTextoEnriquecido={true}
        />
        <Confirmacion
          handleChange={cerrarPopUpAvisoAccion}
          accionConfirmacion={accionBorrar}
          accionDenegacion={compProperties.CONFIR_SIN_ACCION}
          titulo={objText.TEXT_AVISO_IMPORTANTE}
          mostrar={mostrarPopUpAviso}
          isPhoneVersion={isPhoneVersion}
          mensaje={mensajePopUp}
          botonera={compProperties.CONFIR_CANCELAR_ACEPTAR}
          quitarImg={false}
          tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
          isPopUpPdf={false}
          textBotonConfirmarPersonalizado={false}
          isImagenPersonalizada={false}
          centrarContenido={true}
          isTextoEnriquecido={true}
        />

        {/*PopUp contendor del selector de organismos*/}
        <Popover
          open={showOrgSelector}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}>
          <Grid>
            <h2 {...objAtrib.tituloPopUp} className={customStyle.classPopupTitle}>
              Seleccione el organismo
            </h2>
            <Grid container className={customStyle.classGridSelect}>
              <Select
                {...objAtrib.selectOrganismo}
                classes={customStyle}
                options={listadoOrganismos}
                getOptionLabel={(option) => option.nombre}
                onChange={handleChangeOrganismo}
                disabled={false}
              />
            </Grid>
            <Grid container style={{ marginTop: 100 }} >
              <button
                {...objAtrib.buttonCancelar}
                onClick={handleCancelarSolicitud}
                className={customStyle.classButton}>
                {objText.buttonCancelar}
              </button>
              <button
                {...objAtrib.buttonCrear}
                onClick={handleIniciarSolicitud}
                className={customStyle.classButton}>
                {objText.buttonCrear}
              </button>
            </Grid>
          </Grid>
        </Popover>

        {alerts.map(m => (
          <Snackbar open={message.msg} autoHideDuration={5000} onClose={() => setMessage({ severity: "", msg: "" })}>
            <Alert
              severity={message.severity}
              variant="filled"
            >
              {message.msg}
            </Alert>
          </Snackbar>
        ))}

        {/* PopUp para mostrar créditos */}
        <DialogMostrarCredito
          datosCredito={datosCredito}
          open={mostrarPopUpCredito}
          setOpen={setMostrarPopUpCredito}
          title="Mostrar créditos del expediente"
        />

      </Grid>
    </ThemeProvider>
  );
}